// extracted by mini-css-extract-plugin
module.exports = {"groupsList":"_3tbQQfjsW4edVQLTXS-b0z"};